import React from 'react';
import { UserCircleIcon } from '@heroicons/react/24/solid';

const AuthorBox = ({ author }) => {
    if (!author) return null;

    return (
        <div className="mt-12 p-6 md:p-8 rounded-2xl bg-light-card/50 dark:bg-dark-card/50 border border-light-border dark:border-dark-border backdrop-blur-sm shadow-sm flex flex-col md:flex-row gap-6 items-center md:items-start transition-all duration-300 hover:shadow-md">
            <div className="flex-shrink-0">
                {author.avatarUrl ? (
                    <img 
                        src={author.avatarUrl} 
                        alt={author.name} 
                        className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover ring-4 ring-light-primary/20 dark:ring-dark-primary/20 shadow-md"
                    />
                ) : (
                    <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-gradient-to-tr from-light-primary to-blue-400 dark:from-dark-primary dark:to-cyan-500 flex items-center justify-center ring-4 ring-light-primary/20 dark:ring-dark-primary/20 shadow-md">
                        <span className="text-3xl font-bold text-white uppercase drop-shadow-sm">
                            {author.name ? author.name.charAt(0) : 'A'}
                        </span>
                    </div>
                )}
            </div>
            
            <div className="flex flex-col text-center md:text-left flex-grow">
                <span className="text-xs uppercase tracking-wider font-bold text-light-primary dark:text-dark-primary mb-1">
                    About The Author
                </span>
                <h3 className="text-xl md:text-2xl font-bold text-light-text dark:text-dark-text mb-2">
                    {author.name}
                </h3>
                <p className="text-sm md:text-base text-light-text/80 dark:text-dark-text/80 leading-relaxed max-w-2xl">
                    {author.bio || `${author.name} is an editor and content specialist at AircoreDynamics with a focus on aviation, aerospace engineering, and emerging flight technologies. With a background in aerospace sciences and years of experience covering the aviation industry, ${author.name} brings depth and accuracy to every piece published on this platform.`}
                </p>
                <a
                    href={`mailto:${author.email || 'editor@aircoredynamics.com'}`}
                    className="mt-3 inline-flex items-center gap-1.5 text-xs text-light-primary dark:text-dark-primary hover:underline"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    {'editor@aircoredynamics.com'}
                </a>
            </div>
        </div>
    );
};

export default AuthorBox;
